webpackJsonp([110386388766557],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'links-hero' },
	      _react2.default.createElement('div', { className: 'links-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'links-title' },
	      'Links'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'links-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'associations' },
	        _react2.default.createElement(
	          'div',
	          { className: 'associations-title' },
	          'Associations'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'associations-links' },
	          _react2.default.createElement(
	            'li',
	            { className: 'associations-link' },
	            _react2.default.createElement(
	              'a',
	              { className: 'link', rel: 'noopener noreferrer', target: '_blank', href: 'http://www.nefassociation.org/' },
	              'National Equipment Finance Association (NEFA)'
	            ),
	            ' - National association serving small to mid-sized independent equipment finance companies. Formed through the 2009 merger of the United Association of Equipment Leasing (UAEL) and the Eastern Association of Equipment Lessors (EAEL), this new association is building enhanced programs, networking opportunities and industry segment diversity leveraging its broad nationwide base of members and supporters.'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'associations-link' },
	            _react2.default.createElement(
	              'a',
	              { className: 'link', rel: 'noopener noreferrer', target: '_blank', href: 'http://www.elaonline.com/' },
	              'Equipment Leasing and Finance Association (ELFA)'
	            ),
	            ' - Trade association representing financial services companies and manufacturers in the U.S. equipment finance sectors. Its membership is a broad spectrum of industry participants within the U.S. , as well as the international community. The ELFA is the major industry voice representing the interests of the leasing and equipment finance community to the investment and legislative communities within the U.S. as well as a frequent voice in the media advocating for the industry. The name change from the Equipment Leasing Association was intended to reflect a broadened membership who not only offers equipment leasing products but finance opportunities, as well.'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'associations-link' },
	            _react2.default.createElement(
	              'a',
	              { className: 'link', rel: 'noopener noreferrer', target: '_blank', href: 'http://www.naelb.org/' },
	              'National Association of Equipment Lease Brokers (NAELB)'
	            ),
	            ' - Founded in 1990, NAELB has evolved into the main advocate for the independent lease broker community. It was founded and governed by independent brokers who provide significant voluntary support for the programs and benefits offered by the association.'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'associations-link' },
	            _react2.default.createElement(
	              'a',
	              { className: 'link', rel: 'noopener noreferrer', target: '_blank', href: 'http://www.clpfoundation.org/' },
	              'CLFP Foundation'
	            ),
	            ' - Serves as the official governing body and licensor of the CLFP designation, which now has affiliated programs throughout the industrial world. The CLFP designation sets the standard for professionalism in the leasing industry and identifies and recognizes individuals within the industry who have demonstrated their compentency through continued education, testing and conduct.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'links-consulting' },
	        _react2.default.createElement(
	          'div',
	          { className: 'links-consulting-title' },
	          'Sales and Marketing Consulting'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Leasing Solutions LLC maintains business relationships with a number of individuals who are veteran industry experts and offer sales and marketing advise for brokers and lessors. Each one operates differently and to different segments within the equipment leasing industry. I would suggest communicating with each consultant to see what they offer and how they differentiate themselves.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'links-consulting-links' },
	          _react2.default.createElement(
	            'li',
	            { className: 'links-consulting-link' },
	            _react2.default.createElement(
	              'a',
	              { className: 'link', rel: 'noopener noreferrer', target: '_blank', href: 'http://lindakester.com/' },
	              'The Institute For Personal Development'
	            ),
	            ' - The principal, Linda Kester, has been involved in the leasing industry for over twenty years and works with lessors to develop sales programs. Linda is a public speaker, author and sales trainer.'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'links-consulting-link' },
	            _react2.default.createElement(
	              'a',
	              { className: 'link', rel: 'noopener noreferrer', target: '_blank', href: 'http://wheelerbusinessconsulting.com/' },
	              'Wheeler Business Consulting L.L.C.'
	            ),
	            ' - Sales training offered by Scott Wheeler, who can customize a program depending on individual needs.'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'links-consulting-link' },
	            _react2.default.createElement(
	              'a',
	              { className: 'link', rel: 'noopener noreferrer', target: '_blank', href: 'http://www.learnleasing.com/' },
	              'Gerry Egan\'s LearnLeasing.com'
	            ),
	            ' - Gerry Egan offers group coaching, as well as individualized instruction as his sales training technique. Gerry is a former president of the NAELB and is a long-time active supporter of the association.'
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-links-js-71c1e13c9a4d47b40b9d.js